<template>
  <v-app>
    <v-app-bar
      app
      class="menu-bar"
    >
      <v-toolbar-title class="headline text-uppercase headline-margin-left">
        <span class="mobile-normal">DRAGONA </span>
        <span class="font-weight-light mobile-normal">INGATLANOK</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn
        text
        class="mr-2 d-xs-block d-sm-block d-md-none"
        @click="sideNav = !sideNav"
      ><i class="fas fa-bars fa-2x"></i></v-btn>

      <v-navigation-drawer
        v-model="sideNav"
        temporary
        fixed
        right
        app
      >
        <br><br>
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link"
        >
          {{item.title}}
        </v-list-item>
      </v-navigation-drawer>

      <!-- Menu on big screens -->

      <div class="d-none d-md-block">
        <v-btn
          text
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link"
        ><span class="mr-2">{{item.title}}</span></v-btn>
      </div>
    </v-app-bar>

    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<style scoped>
.menu-bar {
  background-color: #212832 !important;
  z-index: 25 !important;
}

.headline-margin-left {
  margin-left: 3rem;
}

.theme--dark.v-application {
    background:  #212832 !important;
    color: #FFFFFF;
}

@media screen and (max-width: 600px) {
  .mobile-normal {
    font-size: 1.1rem !important;
  }
}
</style>


<script>
export default {
  name: "App",
  data: () => ({
    sideNav: false,
    menuItems: [
      { title: "Főoldal", link: "/" },
      { title: "Hasznos tanácsok", link: "/useful" },
      { title: "Eladó, kiadó ingatlanjaink", link: "/actual" },
      { title: "Referenciák", link: "/references" },
    ]
  })
};
</script>
